import React from 'react';
import { FaAward } from 'react-icons/fa';
import { VscFolderLibrary } from 'react-icons/vsc';
import ME from '../../assets/profile_pic.jpeg';
import './intro.css';

const Intro = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="me" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>Tech Lead Enigma Club</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Completed Projects</small>
            </article>
          </div>
          <p>I am currently pursuing a B.Tech in Computer Science and Engineering at Jain University, Bangalore, where I am in my 4th year. This rigorous program has given me a thorough understanding of computer science, from algorithms to software development. With a CGPA of 9.4, I have consistently maintained high academic standards, reflecting my dedication and passion for technology. As I near the completion of my degree, I am excited to apply my knowledge and skills to real-world challenges and contribute to innovative solutions in the tech industry.</p>
          <a href="#contact" className="btn btn-primary">Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default Intro